module.exports = __webpack_public_path__ + "img/ArrowDown.c6b92267.png";